import { useCallback, useRef, useState } from 'react';

export const useFileDropInput = (onFileSelect: (fileList: FileList | null) => void) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const [isDragOver, setIsDragOver] = useState(false);
    const dragCounter = useRef(0);

    const handleDragOver = useCallback((e: React.DragEvent) => {
        e.preventDefault();
    }, []);

    const handleDragEnter = useCallback((e: React.DragEvent) => {
        e.preventDefault();
        dragCounter.current += 1;
        setIsDragOver(true);
    }, []);

    const handleDragLeave = useCallback((e: React.DragEvent) => {
        dragCounter.current -= 1;
        if (dragCounter.current === 0) {
            setIsDragOver(false);
        }
    }, []);

    const handleDrop = useCallback(
        (e: React.DragEvent) => {
            e.preventDefault();
            dragCounter.current = 0;
            setIsDragOver(false);

            const files = e.dataTransfer?.files;
            onFileSelect(files?.length ? files : null);
        },
        [onFileSelect]
    );

    return {
        inputRef,
        isDragOver,
        setIsDragOver,
        handleDrop,
        handleDragOver,
        handleDragEnter,
        handleDragLeave,
    };
};
